"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'webhook.cronIntervals.every_5_minutes': 'Every 5 minutes',
    'webhook.cronIntervals.every_10_minutes': 'Every 10 minutes',
    'webhook.cronIntervals.every_15_minutes': 'Every 15 minutes',
    'webhook.cronIntervals.every_30_minutes': 'Every 30 minutes',
    'webhook.cronIntervals.every_45_minutes': 'Every 45 minutes',
    'webhook.cronIntervals.every_hour': 'Every hour',
    'webhook.cronIntervals.every_2_hours': 'Every 2 hours',
    'webhook.cronIntervals.every_6_hours': 'Every 6 hours',
    'webhook.cronIntervals.every_12_hours': 'Every 12 hours',
    'webhook.cronIntervals.daily': 'Daily (midnight)',
    'webhook.cronIntervals.weekly': 'Weekly (Sunday midnight)',
};
